let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5K06i"), load("dFNh6")]).then(() => parcelRequire('8g9bp'));